import React, { useState } from "react";
import { Modal } from "@/components/Layout";
import { MONTHS } from "./TimeentriesFilters";

/** Confirmare pentru închiderea / redeschiderea întregii luni de pontaj (Admin/HR). */
export default function TimeentriesCloseModal({ reopen, year, month, onClose, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); try { await onConfirm(); } finally { setBusy(false); } };
  const label = `${MONTHS[month - 1]} ${year}`;
  return (
    <Modal title={reopen ? "Redeschidere pontaj" : "Închidere pontaj"} onClose={onClose} width={500}>
      <p style={{ fontSize: 14, color: "#334155", marginTop: 0 }} data-testid="te-close-text">
        {reopen
          ? `Redeschideți pontajul lunii ${label}? Se va putea modifica din nou.`
          : `Închideți pontajul lunii ${label}? Tot pontajul lunii se blochează pentru toți, inclusiv rândurile nevalidate, iar pagina trece la luna următoare. Luna se poate redeschide ulterior de HR sau Admin.`}
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
        <button className="btn btn-secondary" onClick={onClose}>Anulează</button>
        <button className={"btn " + (reopen ? "btn-primary" : "btn-danger")} disabled={busy} onClick={go} data-testid="te-close-confirm">
          {reopen ? "Redeschide" : "Închide pontajul"}
        </button>
      </div>
    </Modal>
  );
}
